import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { SystemComponent } from './system.component';

const routes: Routes = [
  {
    path: '',
    component: SystemComponent,
    children: [
      { path: '', redirectTo: 'appconfiguration', pathMatch: 'full' },
      { path: 'users-management', loadChildren: () => import('./users/users.module').then(m => m.UsersModule) },
      { path: 'groups-management', loadChildren: () => import('./group-management/group-management.module').then(m => m.GroupManagementModule) },
      { path: 'appconfiguration', loadChildren: () => import('./appconfiguration/appconfiguration.module').then(m => m.AppconfigurationModule) },
      { path: 'device-access-management', loadChildren: () => import('./device-access-management/device-access-management.module').then(m => m.DeviceAccessManagementModule) }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class SystemRoutingModule {}
